import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { FeatureErrorBoundary } from '../../../../core-components/theme/components/FeatureErrorBoundary';
import { useHasLocalSession } from '../../../../session/localSession';
import { ALERTS_RETRY_MS } from '../../constants/inApp';

import { AppLanguageFollower } from './AppLanguageFollower';
import { InAppAlerts } from './InAppAlerts';
import { NotificationStream } from './NotificationStream';

const RetryAlertsLater: React.FC<{ onRetry: () => void }> = ({ onRetry }) => {
  useEffect(() => {
    const timer = window.setTimeout(onRetry, ALERTS_RETRY_MS);
    return () => window.clearTimeout(timer);
  }, [onRetry]);
  return null;
};

const retryLater = (reset: () => void): React.ReactNode => <RetryAlertsLater onRetry={reset} />;

const SignedInAlerts: React.FC = () => {
  const signedIn = useHasLocalSession();
  const { pathname } = useLocation();
  if (!signedIn) return null;
  return (
    <>
      <NotificationStream />
      <AppLanguageFollower />
      <FeatureErrorBoundary feature="close-the-loop-inapp" resetKeys={[pathname]} fallback={retryLater}>
        <InAppAlerts />
      </FeatureErrorBoundary>
    </>
  );
};

export const InAppAlertsRoute: React.FC = () => (
  <>
    <SignedInAlerts />
    <Outlet />
  </>
);
